<template>
  <div class="capacity_box" v-loading="loading">
    <div class="">
      <p class="c_text">
        空间容量
        <span>{{ usedSize }}</span>/<span>{{ maxSize }}</span>
      </p>
      <el-progress class="c_progress" :percentage="percentage" />
      <el-button color="#4edf8f" class="c_btn" @click="onExpansion">空间扩容</el-button> 
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import { getCapacityAPI } from '@/api/api';
export default {
  data() {
    return {
      maxSize: null,
      usedSize: null,
      percentage: 0,
      loading: true,
    }
  },
  methods:{
    /** 获取容量信息 */
    getCapacityInfo(){
      getCapacityAPI().then((res)=>{
        this.maxSize = res.data.list.maxSize_text;
        this.usedSize = res.data.list.userSize_text;
        this.percentage = ((res.data.list.usersize / res.data.list.maxsize) * 100).toFixed(2);
        this.loading = false;
      })
    },
    /** 退出登录 */
    outlogin(){
      localStorage.removeItem('token');
      this.$router.push('/login');
    },
    /** 空间扩容 */
    onExpansion(){
      ElMessage({
        message: '功能正在筹备，敬请期待！',
        type: 'warning',
      })
    }
  },
  mounted(){
    this.getCapacityInfo();
  },
}
</script>

<style lang="scss">
  .capacity_box{
    padding-top: 8px;
    .c_text{
      color: #000;
      margin-bottom: 10px;
      font-size: 14px;
      text-align: left;
    }
    .c_progress{
      margin-bottom: 10px;
      .el-progress-bar__outer{
        background-color: #91c9e9;
      }
      .el-progress-bar__inner{
        background-color: #fc9a88;
      }
    }
    .c_btn{
      width: 100%;
      color: #fff;
    }
    .c_btn:hover{
      color: #fff;
    }
  }
</style>